module.exports = __webpack_public_path__ + "img/logo-lg.8eb01b07.svg";